module.exports = __webpack_public_path__ + "static/media/04B.0c343cac.png";